export default "__VITE_ASSET__BvdGlW8A__"